import { combineReducers } from "redux";
// import HotelReducer from "./HotelReducer";
import AuthReducer from "./AuthReducer";
import CandidateProfileReducer from "./CandidateProfileReducer";
import DashboardOverviewReducer from "./CandidateOverviewReducer";
import VendorProfileReducer from "./VendorProfileReducer";
import NewJobReducer from "./NewJobReducer";
import PostedJobViewReducer from "./PostedJobViewReducer";
import ProfileProgressBarReducer from "./ProfileProgressBarReducer";
import ViewJobReducer from "./ViewJobReducer";
import ApplyJobReducer from "./ApplyJobReducer";
import ScheduleInterviewReducer from "./ScheduleInterviewReducer";
import ApplyJobListReducer from "./ApplyJobListReducer";
import InterviewHistoryReducer from "./InterviewHistoryReducer";
import InterviewPlannedReducer from "./InterviewPlannedReducer";
import AddTeamReducer from "./AddTeamReducer";
import TeamTableReducer from "./TeamTableReducer";
import CandidateSkillReducer from "./CandidateSkillReducer";
import AdminDashboardReducer from "./AdminDashboardReducer";
import JobRequestReducer from "./JobRequestReducer";
import EmploymentHistoryListReducer from "./EmploymentHistoryListReducer";
import JobDescriptionReducer from "./JobDescriptionReducer";
import AppliedJobsReducer from "./AppliedJobsReducer";
import CandidateInterviewHistoryReducer from "./CandidateInterviewHistoryReducer";
import CandidateInterviewPlannedReducer from "./CandidateInterviewPlannedReducer";
import CandidateInterviewReducer from "./CandidateInterviewReducer";
import VendorJobDetailsReducer from "./VendorJobDetailsReducer";
import candidateProImgReducer from "./CandidateUpdateProImgReducer";
import candidateProUpdateReducer from "./CandidateProUpdateReducer";
import ContactInfoReducer from "./ContactInfoReducer";
import CandidatePersonalReducer from "./CandidatePersonalReducer";
import candidateSkillUpdateReducer from "./CandidateSkillUpdateReducer";
import UpdateEmpHistoryReducer from "./UpdateEmpHistoryReducer";
import AllCandidateListReducer from "./AllCandidateListReducer";
import AddSkillsReducer from "./AddSkillsReducer";
import DeleteSkillsReducer from "./DeleteSkillsReducer";
import AddEmploymentHistoryReducer from "./AddEmploymentHistoryReducer";
import VendorUpdateProImgReducer from "./VendorUpdateProImgReducer";
import VendorProReducer from "./VendorProReducer";
import ResumeUploadReducer from "./ResumeUploadReducer";
import NewScheduleInterviewReducer from "./NewScheduleInterviewReducer";
import SendRequestReducer from "./SendRequestReducer";
import JobsInterviewPlannedAcceptReducer from "./JobsInterviewPlannedAcceptReducer";
import AllNewJobsListReducer from "./AllNewJobsListReducer";
import WorkPrefrenceReducer from "./WorkPrefrenceReducer";
import CurrencyReducer from "./CurrencyReducer";
import CandidateWorkPreferenceReducer from "./CandidateWorkPreferenceReducer"
import UpdateWorkPrefrenceReducer from "./UpdateWorkPrefReducer";
import VendorOverviewReducer from "./VendorOverviewReducer";
import VendorProfileProgressBarReducer from "./VendorProgressReducer";
import ArchivedMembersReducer from "./ArchivedMembersReducer";
import VendorUpdateComLogoReducer from "./VendorUpdateComLogoReducer";
import TeamApplyJobListReducer from "./TeamApplyJobListReducer";
import candidateProUpdateReducer2 from "./CandidateProUpdateReducer2";
import ClientCandidateListReducer from "./ClientCandidateReducer";
import CandidateAddProjectReducer from "./CandidateAddProjectReducer";
import CandidateUpdateProjectReducer from "./CandidateUpdateProjectReducer";
import VendorJobUpdateReducer from "./VendorJobUpdateReducer";
import CandidateEducationReducer from "./CandidateEducationReducer";
import CandidateCertificationReducer from "./CandidateCertificationReducer";
import interviewFeedbackReducer from "./FeedbackDataReducer"
import AppliedJobsVendorReducer from "./AppliedJobsVendorReducer";
import CancelInterviewReducer from "./CancelInterviewVendorReducer";
import VendorTeamTableReducer from "./VendorTeamTableReducer"
import InvitationsReducer from "./InvitationsReducer";
import RequestReducer from "./RequestReducer";
import EditJobReducer from "./EditJobReducer"
import VendorDashboardReducer from "./VendorDashboardReducer";
import InterviewerInterviewPlannedReducer from "./InterviewerInterviewPlannedReducer"
import TeamMemberInterviewReducer from "./TeamMemberInterviewReducer.js"
import CandidatePageReducer from "./CandidatePageReducer.js";
import JobDetailsReducer from "./JobDetailsReducer.js";
import Interview_ListReducer from "./Interview_ListReducer.js";
import PurchaseOrderReducer from "./PurchaseOrderReducer.js";
import MasterSkillReducer from "./MasterSkillReducer.js";
import SubscriptionReducer from "./SubscriptionReducer.js"


const rootReducer = combineReducers({
    //Hotel: HotelReducer
    EditJobReducer: EditJobReducer,
    RequestReducer: RequestReducer,
    InvitationsReducer: InvitationsReducer,
    VendorTeamTableReducer: VendorTeamTableReducer,
    InterviewerInterviewPlannedReducer: InterviewerInterviewPlannedReducer,
    CancelInterviewReducer: CancelInterviewReducer,
    TeamMemberInterviewReducer: TeamMemberInterviewReducer,
    AppliedJobsVendorReducer: AppliedJobsVendorReducer,
    interviewFeedback: interviewFeedbackReducer,
    Auth: AuthReducer,
    Profile: CandidateProfileReducer,
    ProfileImg: candidateProImgReducer,
    ProfileUpdateData: candidateProUpdateReducer,
    CandidateSkills: CandidateSkillReducer,
    CandidateUpdatedSkills: candidateSkillUpdateReducer,
    UpdatedEmpHistory: UpdateEmpHistoryReducer,
    ContactInfo: ContactInfoReducer,
    CandidatePersonal: CandidatePersonalReducer,
    DashboardOverviewReducer: DashboardOverviewReducer,
    VendorProfile: VendorProfileReducer,
    JobList: NewJobReducer,
    JobView: PostedJobViewReducer,
    ProgressBAR: ProfileProgressBarReducer,
    VendorProgressBAR: VendorProfileProgressBarReducer,
    ArchivedMembers: ArchivedMembersReducer,
    ViewJob: ViewJobReducer,
    ApplyJob: ApplyJobReducer,
    ScheduleInterview: ScheduleInterviewReducer,
    ApplyJobList: ApplyJobListReducer,
    InterviewHistory: InterviewHistoryReducer,
    InterviewPlanned: InterviewPlannedReducer,
    AddTeam: AddTeamReducer,
    TeamTable: TeamTableReducer,
    AdminDashboardList: AdminDashboardReducer,
    JobRequest: JobRequestReducer,
    EmploymentHistoryList: EmploymentHistoryListReducer,
    JobDescription: JobDescriptionReducer,
    AppliedJobs: AppliedJobsReducer,
    CandidateJobHistory: CandidateInterviewHistoryReducer,
    CandidateJobPlanned: CandidateInterviewPlannedReducer,
    CandidateInterview: CandidateInterviewReducer,
    VendorJobDetails: VendorJobDetailsReducer,
    AllCandidateListData: AllCandidateListReducer,
    AddSkillsData: AddSkillsReducer,
    DeleteSkillsData: DeleteSkillsReducer,
    AddEmploymentHistoryData: AddEmploymentHistoryReducer,
    VendorUpdateProImgData: VendorUpdateProImgReducer,
    VendorProData: VendorProReducer,
    ResumeUploadData: ResumeUploadReducer,
    NewScheduleInterviewData: NewScheduleInterviewReducer,
    SendRequestData: SendRequestReducer,
    JobsInterviewPlannedAcceptData: JobsInterviewPlannedAcceptReducer,
    AllNewJobsListData: AllNewJobsListReducer,
    WorkPrefrenceData: WorkPrefrenceReducer,
    CurrencyData: CurrencyReducer,
    CandidateWorkPreferenceData: CandidateWorkPreferenceReducer,
    UpdateWorkPrefrence: UpdateWorkPrefrenceReducer,
    VendorOverview: VendorOverviewReducer,
    VendorUpdateComLogo: VendorUpdateComLogoReducer,
    TeamAppliedJobs: TeamApplyJobListReducer,
    candidateProUpdate2: candidateProUpdateReducer2,
    ClientCandidateList: ClientCandidateListReducer,
    CandidateAddProject: CandidateAddProjectReducer,
    UpdateProject: CandidateUpdateProjectReducer,
    VendorJobUpdate: VendorJobUpdateReducer,
    CandidateEducation: CandidateEducationReducer,
    CandidateCertification: CandidateCertificationReducer,
    VendorSideDashboard: VendorDashboardReducer,
    CandidatePageDashboard: CandidatePageReducer,
    JobPageDashboard: JobDetailsReducer,
    InterviewDashboard: Interview_ListReducer,
    PurchaseOrderDetails: PurchaseOrderReducer,
    MasterTableDetails: MasterSkillReducer,
    SubscriptionListing: SubscriptionReducer,
});

export default rootReducer;
